window.addEventListener('SITE_START', () => {
  const $mainPopup = document.querySelector('.home-kv-popup');
  if (!$mainPopup) return;
  const $toggle = $mainPopup.querySelector('.__toggle');
  const $close = $mainPopup.querySelector('.__close');
  $toggle?.addEventListener('click', () => {
    $mainPopup.classList.add('--active');
  });
  $close?.addEventListener('click', () => {
    $mainPopup.classList.remove('--active');
  });

  new Swiper($mainPopup.querySelector('.swiper'), {
    speed: 400,
    loop: true,
    pagination: {
      el: $mainPopup.querySelector('.__pagination'),
      clickable: true,
    },
  });
});

// kv
window.addEventListener('SITE_START', () => {
  const $section = document.querySelector('#homeKV');
  if (!$section) return;
  const $title = $section.querySelector('.slider-desc .__title');
  $title.innerHTML = '';
  const SPEED = 600;
  let autoPlayTimeout = null;
  const swiper = new Swiper($section.querySelector('.slider .swiper'), {
    loop: true,
    parallax: true,
    speed: SPEED,
    pagination: {
      el: $section.querySelector('.__indices'),
      clickable: true,
      renderBullet: function (index, className) {
        return '<button class="' + className + '" aria-label="Slide to ' + (index + 1) + '"></button>';
      },
    },
    on: {
      slideChangeTransitionEnd: function () {
        requestAnimationFrame(() => {
          showSlide();
        });
      },
      slideChangeTransitionStart: function () {
        const currentIndex = swiper.activeIndex;
        const bg = swiper.slides[currentIndex].querySelector('.__bg');
        const img = bg.querySelector('img');
        if (img) {
          gsap.fromTo(
            bg,
            {
              scale: 1.2,
            },
            {
              scale: 1,
              duration: 10,
              ease: Linear.easeNone,
            }
          );
        }
      },
    },
  });

  const showSlide = (delay = 0) => {
    const currentIndex = swiper.activeIndex;
    const currentSlide = swiper.slides[currentIndex];
    const duration = currentSlide.querySelector('.slide-item').dataset.duration;
    const index = document.querySelector(
      '#homeKV .__indices .swiper-pagination-bullet:nth-child(' + (currentIndex + 1) + ')'
    );

    document.querySelectorAll('#homeKV .slider video').forEach((el) => {
      el.pause();
      el.currentTime = 0;
    });

    const video = currentSlide.querySelector('video');
    if (video) {
      video.currentTime = 0;
      video.play();
    }

    index.style.setProperty('--duration', duration + 's');
    if (autoPlayTimeout) clearTimeout(autoPlayTimeout);
    autoPlayTimeout = setTimeout(() => {
      swiper.slideNext();
    }, duration * 1000);

    $title.innerHTML = '';
    const titleText = currentSlide.querySelector('.__title').innerHTML;
    $title.innerHTML = titleText;
    const titleTS = new SplitText($title, {
      type: 'lines, words, chars',
      linesClass: '__line',
      wordsClass: '__word',
      charsClass: '__char',
    });
    gsap.fromTo(
      titleTS.words,
      {
        yPercent: 120,
      },
      {
        yPercent: 0,
        duration: 1,
        ease: Circ.easeOut,
        stagger: 0.08,
        delay: delay,
      }
    );
  };

  showSlide(1);

  ScrollTrigger.create({
    trigger: '#homeKV',
    start: 'top top',
    end: 'bottom top',
    onUpdate: (self) => {
      const progress = self.progress;
      gsap.set('#homeKV .slider', {
        yPercent: progress * 50,
      });
    },
  });
});
